import React, { useState } from 'react';
import { injectIntl, IntlShape } from 'react-intl';
import { translate } from 'containers/services/translate';
import { Checkbox, FormControlLabel, TextField } from '@material-ui/core';
import { get, isEmpty } from 'lodash';
import { Config, Listings } from 'containers/AppContainer/typings';
import { LISTINGS } from 'containers/data-structure';
import { FraudMotifDialogWrapper } from 'containers/PreOpeningPage/styled-component';
import messages from 'containers/PreOpeningPage/messages';
import { OTHER_MOTIF_ID } from 'containers/PreOpeningPage/constants';
import { useEffect } from 'react';

export interface FraudMotifDialogProps {
  listings?: Listings;
  intl: IntlShape;
  fraudMotifs: any;
  setFraudMotifs: Function;
  isOpen: boolean;
  setIsFraudMotifDrawerOpen: Function;
  claimToPreopen?: any;
  updateFilde?: Function;
  setClaimRecap?: Function;
  claimRecap?: any;
  commentMotif?: any;
  setCommentMotif?: Function;
  fraudInfo: any;
  setFraudInfo: any;
}

export const FraudMotifDialog: React.FC<FraudMotifDialogProps> = ({
  listings,
  fraudMotifs: fraudMotifsSet,
  setFraudMotifs: setFraudMotifsSetter,
  isOpen,
  setIsFraudMotifDrawerOpen,
  commentMotif,
  setCommentMotif,
  ...props
}): JSX.Element => {
  const [fraudMotifs, setFraudMotifs] = useState<Set<number>>(new Set());

  const [showCommentMotif, setShowCommentMotif] = useState<boolean>(false);

  useEffect(() => {
    const fraudRecap = get(props.claimToPreopen, 'claim.fraudInfo[0]', []);
    if (!isEmpty(get(props.fraudInfo, 'fraudMotifs', []))) {
      setFraudMotifs(new Set([...get(props.fraudInfo, 'fraudMotifs', [])]));
    } else if (!isEmpty(fraudRecap)) {
      const motifsIds = get(fraudRecap, 'fraudInfoMotif', []).map(
        (el: any) => el.motifId,
      );
      setFraudMotifs(new Set(motifsIds));
    }
  }, [props.claimToPreopen, props?.fraudInfo?.fraudMotifs]);

  const handleCancelFraudMotif = () => {
    setIsFraudMotifDrawerOpen(false);
  };

  const handleValidateFraudMotif = () => {
    setIsFraudMotifDrawerOpen(false);
    setFraudMotifsSetter(new Set(fraudMotifs));
    setFraudMotifs(new Set());
    props.setFraudInfo({
      ...props.fraudInfo,
      fraudMotifs: [...new Set(fraudMotifs)],
    });
    if (get(props.claimToPreopen, 'fraudInfo')) {
      get(props.claimToPreopen, 'fraudInfo')['fraudMotifs'] = [
        ...new Set(fraudMotifs),
      ];
    } else {
      props.claimToPreopen['fraudInfo'] = {
        ...props.fraudInfo,
        fraudMotifs: [...new Set(fraudMotifs)],
      };
    }
    props.updateFilde &&
      props.updateFilde({
        ...props.claimToPreopen,
        fraudInfo: {
          ...props.claimToPreopen.fraudInfo,
          fraudMotifs: [...new Set(fraudMotifs)],
        },
      });
    props.setClaimRecap &&
      props.setClaimRecap({
        ...props.claimRecap,
        claim: {
          ...get(props.claimRecap, 'claim'),
          fraudInfo: [
            {
              ...get(props.claimRecap, 'claim.fraudInfo[0]'),
              fraudMotifs: [...new Set(fraudMotifs)],
            },
          ],
        },
      });
  };

  const handleFraudMotifChangeCheckBox = (id: number) => (
    e: React.ChangeEvent<{ value: string; checked: boolean }>,
  ) => {
    const fraudMotifSet = new Set(fraudMotifs);
    if (e.target.checked) {
      if (id === OTHER_MOTIF_ID) setShowCommentMotif(true);
      fraudMotifSet.add(id);
    } else {
      if (id === OTHER_MOTIF_ID) setShowCommentMotif(false);
      fraudMotifSet.delete(id);
    }
    setFraudMotifs(fraudMotifSet);
  };

  const handleChangeCommentMotif = (
    event: React.ChangeEvent<{
      name?: string;
      value?: any;
    }>,
  ) => {
    setCommentMotif && setCommentMotif(event.target.value);
    if (get(props.claimToPreopen, 'fraudInfo'))
      get(props.claimToPreopen, 'fraudInfo')['commentMotif'] =
        event.target.value;
    props.updateFilde &&
      props.updateFilde({
        ...props.claimToPreopen,
        fraudInfo: {
          ...props.claimToPreopen.fraudInfo,
          commentMotif: event.target.value,
        },
      });
    props.setClaimRecap &&
      props.setClaimRecap({
        ...props.claimRecap,
        claim: {
          ...get(props.claimRecap, 'claim'),
          fraudInfo: [
            {
              ...get(props.claimRecap, 'claim.fraudInfo[0]'),
              commentMotif: event.target.value,
            },
          ],
        },
      });
  };

  const isFraudMotifChecked = (id: number) => fraudMotifs.has(id);

  return (
    <>
      <FraudMotifDialogWrapper
        className="fraud-motif-content"
        handleValidate={handleValidateFraudMotif}
        handleClose={handleCancelFraudMotif}
        title={translate(messages.fraudDialogTitle, props)}
        cancelTitle={translate(messages.fraudDialogCancel, props)}
        confirmTitle={translate(messages.fraudDialogValidate, props)}
        open={isOpen}
        validateButtonDisabled={
          isEmpty(fraudMotifs) ||
          (fraudMotifs.has(OTHER_MOTIF_ID) && isEmpty(commentMotif))
        }
      >
        {get(listings, LISTINGS.FRAUD_MOTIF, []).map(
          (fraudMotif: Config, index: number) => (
            <FormControlLabel
              key={index}
              control={
                <Checkbox
                  data-testid={`checkbox-${index}`}
                  checked={isFraudMotifChecked(fraudMotif.id)}
                  color="primary"
                  onChange={handleFraudMotifChangeCheckBox(fraudMotif.id)}
                />
              }
              label={fraudMotif.title}
            />
          ),
        )}
        {showCommentMotif && (
          <div style={{ marginTop: '12px' }}>
            <TextField
              label={translate(messages.comment, props)}
              name={translate(messages.comment, props)}
              value={commentMotif}
              onChange={handleChangeCommentMotif}
            />
          </div>
        )}
      </FraudMotifDialogWrapper>
    </>
  );
};

export default injectIntl(FraudMotifDialog);
